// Dependencies
import React from 'react';
import { ThemeContext } from '../../../components/theme/Theme.jsx';
import radium from 'radium';

function Title(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		fontSize: context.themeManager.value('shopping-cart-event-title', 'fontSize', 'font-size-200'),
		lineHeight: context.themeManager.value('shopping-cart-event-title', 'lineHeight', 'line-height-100'),
		color: context.themeManager.value('shopping-cart-event-title', 'color', 'fg-color-text'),
		fontWeight: '800',
		wordBreak: 'keep-all',
	};

	const Headline = props.headlineLevel? props.headlineLevel : 'h1';
	return (
		<Headline style={style}>{props.title}</Headline>
	);
}

export default radium(Title);
